import cls from "@fvilers/cls";
import styles from "./Switch.module.css";

type SwitchLabelProps = {
  children: React.ReactNode;
  className?: string;
  label: React.ReactNode;
  placement?: "end" | "start";
  title?: string;
};

export function SwitchLabel({
  children,
  className,
  label,
  placement = "end",
  title,
}: SwitchLabelProps) {
  return (
    <label
      className={cls(styles.SwitchLabel, className)}
      data-slot="control"
      title={title}
    >
      {placement === "start" && (
        <span className={styles.SwitchLabelText} data-slot="text">
          {label}
        </span>
      )}
      {children}
      {placement === "end" && (
        <span className={styles.SwitchLabelText} data-slot="text">
          {label}
        </span>
      )}
    </label>
  );
}
